import React from 'react';

export default function StatsCard({ title, value, icon: Icon, color = 'primary', subtitle, trend }) {
  const colorMap = {
    primary: 'red',
    secondary: 'yellow',
    green: 'green',
    blue: 'blue',
    purple: 'purple',
  };

  const bgColor = colorMap[color] || 'red';
  
  return (
    <div className="stat-card">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className="text-2xl font-bold text-gray-900 mt-1">{value}</p>
          {subtitle && <p className="text-xs text-gray-500 mt-1">{subtitle}</p>}
          {trend && (
            <p className={`text-xs font-medium mt-1 ${trend > 0 ? 'text-green-600' : 'text-red-600'}`}>
              {trend > 0 ? '+' : ''}{trend}% from last month
            </p>
          )}
        </div>
        <div className={`p-3 rounded-lg bg-${bgColor}-100`}>
          <Icon className={`w-6 h-6 text-${bgColor}-600`} />
        </div>
      </div>
    </div>
  );
}